import { Injectable } from "@angular/core"
import { HttpClient } from "@angular/common/http";
import { environment } from "@env/environment";

import { Observable, of } from "rxjs";
import { delay, map, take } from "rxjs/operators";

import { AdminCatalogUpsertResult, AdminCatalogCounts } from "@app-model/admin/catalog/catalog.model";

import {
  AdminCatalogCategoryData,
  AdminCatalogCategoryUpsert,
  AdminCatalogCategoryPaginationPayload,
  AdminCatalogCategoryPaginationResult,
} from "@app-model/admin/catalog/category.model";

import {
  AdminCatalogMakeUpsert,
  AdminCatalogMakeData,
  AdminCatalogMakePaginationPayload,
  AdminCatalogMakePaginationResult,
} from "@app-model/admin/catalog/make.model";

import {
  AdminCatalogModelData,
  AdminCatalogModelUpsert,
  AdminCatalogModelPaginationPayload,
  AdminCatalogModelPaginationResult,
} from "@app-model/admin/catalog/models.model";

import {
    AdminCatalogSuperbidModelPaginationPayload,
    AdminCatalogSuperbidModelPaginationResult
} from "@app-model/admin/catalog/superbid-sync.model";

@Injectable({
  providedIn: 'root'
})
export class CatalogService {

  constructor(
    private readonly _http: HttpClient
  ) { }

  public fetchCatalogCounts(): Observable<AdminCatalogCounts> {
    // const apiUrl = `${environment.api}/catalog/counts`;
    // return this._http.get<AdminCatalogCounts>(apiUrl)
    //   .pipe(
    //     take(1)
    //   );
    return of(<AdminCatalogCounts>{
        numberOfCategories: 48,
        numberOfMakes: 96,
        numberOfModels: 513,
        numberOfPrices: 251,
    }).pipe(delay(1000));
  }


  /**
   * @param id Category ID
   */
  public getCategory(id: string): Observable<AdminCatalogCategoryData> {
    const pagination: AdminCatalogCategoryPaginationPayload = <AdminCatalogCategoryPaginationPayload>{
      pageSize: 1,
      value: id,
    };
    return this.fetchCategories(pagination)
      .pipe(
        map(result => result.data.pop() ?? null),
      );
  }
  
  public fetchAllCategories(): Observable<AdminCatalogCategoryData[]> {
    return this.fetchCategories({
      page: null,
      pageSize: null,
      sortField: 'name',
      sortDirection: 'ASC',
      value: null,
    })
    .pipe(
      map(result => result.data),
    );
  }

  public fetchCategories(pagination: AdminCatalogCategoryPaginationPayload): Observable<AdminCatalogCategoryPaginationResult> {
    const apiUrl = `${environment.api}/category/search`;
    return this._http.post<AdminCatalogCategoryPaginationResult>(apiUrl, pagination)
      .pipe(
        take(1)
      );
    // const data: AdminCatalogCategoryData[] = [
    //   {
    //     id: "1",
    //     name: "Officia Proident",
    //     segment: "HEAVY",
    //     numberOfProducts: 64,
    //     numberOfSubcategories: 46,
    //     slug: "lorem-ipsum-dolor",
    //     subcategoriesNames: ["Consectetur adipiscing", "Sed do eiusmod"],
    //   },
    //   {
    //     id: "2",
    //     name: "Sit Anim",
    //     segment: "HEAVY_TOOL",
    //     numberOfProducts: 43,
    //     numberOfSubcategories: 76,
    //     slug: "lorem-ipsum-dolor",
    //     subcategoriesNames: ["Consectetur adipiscing", "Sed do eiusmod"],
    //   },
    //   {
    //     id: "3",
    //     name: "Cupidatat Ut",
    //     segment: "IMPLEMENTS",
    //     numberOfProducts: 93,
    //     numberOfSubcategories: 25,
    //     slug: "lorem-ipsum-dolor",
    //     subcategoriesNames: ["Consectetur adipiscing", "Sed do eiusmod"],
    //   },
    //   {
    //     id: "4",
    //     name: "Quis Fugiat",
    //     segment: "HEAVY",
    //     numberOfProducts: 80,
    //     numberOfSubcategories: 60,
    //     slug: "lorem-ipsum-dolor",
    //     subcategoriesNames: ["Consectetur adipiscing", "Sed do eiusmod"],
    //   },
    //   {
    //     id: "5",
    //     name: "Consectetur Incididunt",
    //     segment: "HEAVY_TOOL",
    //     numberOfProducts: 18,
    //     numberOfSubcategories: 35,
    //     slug: "lorem-ipsum-dolor",
    //     subcategoriesNames: ["Consectetur adipiscing", "Sed do eiusmod"],
    //   },
    //   {
    //     id: "6",
    //     name: "Reprehenderit Sit",
    //     segment: "AGRO",
    //     numberOfProducts: 85,
    //     numberOfSubcategories: 68,
    //     slug: "lorem-ipsum-dolor",
    //     subcategoriesNames: ["Consectetur adipiscing", "Sed do eiusmod"],
    //   },
    //   {
    //     id: "7",
    //     name: "Aliqua Cillum",
    //     segment: "HEAVY",
    //     numberOfProducts: 38,
    //     numberOfSubcategories: 82,
    //     slug: "lorem-ipsum-dolor",
    //     subcategoriesNames: ["Consectetur adipiscing", "Sed do eiusmod"],
    //   },
    //   {
    //     id: "8",
    //     name: "Adipisicing Elit",
    //     segment: "IMPLEMENTS",
    //     numberOfProducts: 85,
    //     numberOfSubcategories: 20,
    //     slug: "lorem-ipsum-dolor",
    //     subcategoriesNames: ["Consectetur adipiscing", "Sed do eiusmod"],
    //   },
    //   {
    //     id: "9",
    //     name: "Ex Sint",
    //     segment: "IMPLEMENTS",
    //     numberOfProducts: 52,
    //     numberOfSubcategories: 89,
    //     slug: "lorem-ipsum-dolor",
    //     subcategoriesNames: ["Consectetur adipiscing", "Sed do eiusmod"],
    //   },
    //   {
    //     id: "10",
    //     name: "Quis Elit",
    //     segment: "HEAVY",
    //     numberOfProducts: 16,
    //     numberOfSubcategories: 100,
    //     slug: "lorem-ipsum-dolor",
    //     subcategoriesNames: ["Consectetur adipiscing", "Sed do eiusmod"],
    //   },
    //   {
    //     id: "11",
    //     name: "Labore Consectetur",
    //     segment: "IMPLEMENTS",
    //     numberOfProducts: 27,
    //     numberOfSubcategories: 71,
    //     slug: "lorem-ipsum-dolor",
    //     subcategoriesNames: ["Consectetur adipiscing", "Sed do eiusmod"],
    //   },
    // ];
    // const response: AdminCatalogCategoryPaginationResult = {
    //   actualPage: 0,
    //   data: [...data].sort(() => Math.random() - 0.5).slice(0, 10),
    //   numberOfPages: 6,
    //   totalElements: data.length,
    // };
    // return of(response).pipe(delay(3000));
  }

  public saveCategory(data: AdminCatalogCategoryUpsert): Observable<AdminCatalogUpsertResult> {
    const apiUrl = `${environment.api}/category/upsert`;
    return this._http.post<AdminCatalogUpsertResult>(apiUrl, data)
      .pipe(
        take(1)
      );
    // const response: AdminCatalogCategoryUpsertResult = {
    //   success: true,
    //   message: '1234567890',
    // };
    // return of(response).pipe(delay(3000));
  }

  public fetchMakes(pagination: AdminCatalogMakePaginationPayload): Observable<AdminCatalogMakePaginationResult> {
    const apiUrl = `${environment.api}/make/search`;
    return this._http.post<AdminCatalogMakePaginationResult>(apiUrl, pagination)
      .pipe(
        take(1)
      );
    // const data: AdminCatalogMakeList[] = [
    //   {
    //     id: '1',
    //     name: 'Agricolasforn',
    //     numberOfModels: 32,
    //     numberOfProducts: 351,
    //   },
    //   {
    //     id: '2',
    //     name: 'Casale',
    //     numberOfModels: 24,
    //     numberOfProducts: 247,
    //   },
    //   {
    //     id: '3',
    //     name: 'Ipacol',
    //     numberOfModels: 245,
    //     numberOfProducts: 232,
    //   },
    //   {
    //     id: '4',
    //     name: 'Nogueira',
    //     numberOfModels: 4,
    //     numberOfProducts: 211,
    //   },
    //   {
    //     id: '5',
    //     name: 'Realmaq',
    //     numberOfModels: 14,
    //     numberOfProducts: 198,
    //   },
    //   {
    //     id: '6',
    //     name: 'Schemaq',
    //     numberOfModels: 7,
    //     numberOfProducts: 187,
    //   },
    //   {
    //     id: '7',
    //     name: 'Massey Ferguson',
    //     numberOfModels: 65,
    //     numberOfProducts: 175,
    //   },
    //   {
    //     id: '8',
    //     name: 'Buffalo',
    //     numberOfModels: 45,
    //     numberOfProducts: 163,
    //   },
    //   {
    //     id: '9',
    //     name: 'Caterpillar',
    //     numberOfModels: 34,
    //     numberOfProducts: 134,
    //   },
    //   {
    //     id: '10',
    //     name: 'Claas',
    //     numberOfModels: 23,
    //     numberOfProducts: 89,
    //   },
    //   {
    //     id: '11',
    //     name: 'John Deere',
    //     numberOfModels: 22,
    //     numberOfProducts: 213,
    //   },
    // ];
    // const response: AdminCatalogMakePaginationResult = {
    //   actualPage: 0,
    //   data: [...data].sort(() => Math.random() - 0.5).slice(0, 10),
    //   numberOfPages: 6,
    //   totalElements: data.length,
    // };
    // return of(response).pipe(delay(3000));
  }

  /**
   * @param id Make ID
   */
  public getMake(id: string): Observable<AdminCatalogMakeData> {
    const pagination: AdminCatalogMakePaginationPayload = <AdminCatalogMakePaginationPayload>{
      pageSize: 1,
      value: id,
    };
    return this.fetchMakes(pagination)
      .pipe(
        map(result => result.data.pop() ?? null),
      );
  }

  public saveMake(data: AdminCatalogMakeUpsert): Observable<AdminCatalogUpsertResult> {
    const apiUrl = `${environment.api}/make/upsert`;
    return this._http.post<AdminCatalogUpsertResult>(apiUrl, data)
      .pipe(
        take(1)
      );
    // const response: AdminCatalogUpsertResult = {
    //   success: true,
    //   message: '1234567890',
    // };
    // return of(response).pipe(delay(3000));
  }

  public fetchModels(pagination: AdminCatalogModelPaginationPayload): Observable<AdminCatalogModelPaginationResult> {
    const apiUrl = `${environment.api}/model/search`;
    return this._http.post<AdminCatalogModelPaginationResult>(apiUrl, pagination)
      .pipe(
        take(1)
      );
    // const data: AdminCatalogModelData[] = [
    //   {
    //     id: '1',
    //     categoryId: '64ff53122c501b2b3fc38342',
    //     categoryName: 'Dolor sit amet',
    //     makeId: '65454c0c72f7b178d86e6be1',
    //     makeName: 'Lorem Ipsum',
    //     name: 'Caterpillar 12F',
    //     segment: 'AGRO',
    //     subcategoryId: '1',
    //     subcategoryName: 'Consectetur adipiscing',
    //     prices: {
    //       '2024': 2500000,
    //       '2018': 1850000,
    //     },
    //   },
    //   {
    //     id: '2',
    //     categoryId: '64ff53122c501b2b3fc38342',
    //     categoryName: 'Dolor sit amet',
    //     makeId: '65454c0c72f7b178d86e6be1',
    //     makeName: 'Lorem Ipsum',
    //     name: 'Caterpillar 12G',
    //     segment: 'AGRO',
    //     subcategoryId: '1',
    //     subcategoryName: 'Consectetur adipiscing',
    //     prices: {
    //       '2022': 250000,
    //       '2011': 96000,
    //     },
    //   },
    //   {
    //     id: '3',
    //     categoryId: '64ff53122c501b2b3fc38342',
    //     categoryName: 'Dolor sit amet',
    //     makeId: '65454c0c72f7b178d86e6be1',
    //     makeName: 'Lorem Ipsum',
    //     name: 'Caterpillar D4E',
    //     segment: 'AGRO',
    //     subcategoryId: '1',
    //     subcategoryName: 'Consectetur adipiscing',
    //     prices: {
    //       '2023': 1300000,
    //       '2019': 1200000,
    //       '2011': 975000,
    //       '2005': 780000,
    //     },
    //   },
    //   {
    //     id: '4',
    //     categoryId: '64ff53122c501b2b3fc38342',
    //     categoryName: 'Dolor sit amet',
    //     makeId: '65454c0c72f7b178d86e6be1',
    //     makeName: 'Lorem Ipsum',
    //     name: 'Volvo 124',
    //     segment: 'AGRO',
    //     subcategoryId: '1',
    //     subcategoryName: 'Consectetur adipiscing',
    //     prices: {
    //       '2024': 880000,
    //       '2020': 830000,
    //     },
    //   },
    //   {
    //     id: '5',
    //     categoryId: '64ff53122c501b2b3fc38342',
    //     categoryName: 'Dolor sit amet',
    //     makeId: '65454c0c72f7b178d86e6be1',
    //     makeName: 'Lorem Ipsum',
    //     name: 'Volvo 150',
    //     segment: 'AGRO',
    //     subcategoryId: '1',
    //     subcategoryName: 'Consectetur adipiscing',
    //     prices: {
    //       '2023': 290000,
    //       '2021': 250000,
    //     },
    //   },
    //   {
    //     id: '6',
    //     categoryId: '64ff53122c501b2b3fc38342',
    //     categoryName: 'Dolor sit amet',
    //     makeId: '65454c0c72f7b178d86e6be1',
    //     makeName: 'Lorem Ipsum',
    //     name: 'Bobcat 553',
    //     segment: 'AGRO',
    //     subcategoryId: '1',
    //     subcategoryName: 'Consectetur adipiscing',
    //     prices: {
    //       '2022': 450000,
    //       '2014': 297000,
    //       '2007': 138000,
    //     },
    //   },
    //   {
    //     id: '7',
    //     categoryId: '64ff53122c501b2b3fc38342',
    //     categoryName: 'Dolor sit amet',
    //     makeId: '65454c0c72f7b178d86e6be1',
    //     makeName: 'Lorem Ipsum',
    //     name: 'Bobcat 753',
    //     segment: 'AGRO',
    //     subcategoryId: '1',
    //     subcategoryName: 'Consectetur adipiscing',
    //     prices: {
    //       '2024': 950000,
    //       '2020': 750000,
    //       '2019': 745000,
    //       '2016': 700500,
    //     },
    //   },
    //   {
    //     id: '8',
    //     categoryId: '64ff53122c501b2b3fc38342',
    //     categoryName: 'Dolor sit amet',
    //     makeId: '65454c0c72f7b178d86e6be1',
    //     makeName: 'Lorem Ipsum',
    //     name: 'Fankhauser 2100',
    //     segment: 'AGRO',
    //     subcategoryId: '1',
    //     subcategoryName: 'Consectetur adipiscing',
    //     prices: {
    //       '2023': 890000,
    //     },
    //   },
    //   {
    //     id: '9',
    //     categoryId: '64ff53122c501b2b3fc38342',
    //     categoryName: 'Dolor sit amet',
    //     makeId: '65454c0c72f7b178d86e6be1',
    //     makeName: 'Lorem Ipsum',
    //     name: 'Fankhauser 2115',
    //     segment: 'AGRO',
    //     subcategoryId: '1',
    //     subcategoryName: 'Consectetur adipiscing',
    //     prices: {
    //       '2024': 172000,
    //       '2023': 168000,
    //       '2022': 162000,
    //       '2020': 157000,
    //       '2018': 148000,
    //       '2017': 146000,
    //       '2016': 140000,
    //       '2015': 138000,
    //       '2014': 136000,
    //       '2013': 132000,
    //       '2012': 130000,
    //       '2010': 125000,
    //       '2009': 120000,
    //       '2008': 112000,
    //       '2006': 102000,
    //     },
    //   },
    //   {
    //     id: '10',
    //     categoryId: '64ff53122c501b2b3fc38342',
    //     categoryName: 'Dolor sit amet',
    //     makeId: '65454c0c72f7b178d86e6be1',
    //     makeName: 'Lorem Ipsum',
    //     name: 'Jcb 8035',
    //     segment: 'AGRO',
    //     subcategoryId: '1',
    //     subcategoryName: 'Consectetur adipiscing',
    //     prices: {
    //       '2023': 900000,
    //       '2020': 500000,
    //       '2008': 115000,
    //     },
    //   },
    // ];
    // const response: AdminCatalogModelPaginationResult = {
    //   actualPage: 0,
    //   data: [...data].sort(() => Math.random() - 0.5).slice(0, 10),
    //   numberOfPages: 1,
    //   totalElements: 10,
    // };
    // return of(response).pipe(delay(1000));
  }

  /**
   * @param id Model ID
   */
  public getModel(id: string): Observable<AdminCatalogModelData> {
    const pagination: AdminCatalogModelPaginationPayload = <AdminCatalogModelPaginationPayload>{
      pageSize: 1,
      value: id,
    };
    return this.fetchModels(pagination)
      .pipe(
        map(result => result.data.pop() ?? null),
      );
    // const response: AdminCatalogModelData = {
    //   id: '1',
    //   name: 'Lorem Ipsum dolor sit amet',
    //   makeId: '1',
    //   makeName: 'Lorem Ipsum',
    //   segment: 'AGRO',
    //   categoryId: '1',
    //   categoryName: 'Dolor sit amet',
    //   subcategoryId: '1',
    //   prices: {
    //     '2015': 960000,
    //     '2018': 1100000,
    //     '2024': 1300000,
    //   },
    // };
    // return of(response).pipe(delay(1000));
  }

  public saveModel(data: AdminCatalogModelUpsert): Observable<AdminCatalogUpsertResult> {
    const apiUrl = `${environment.api}/model/upsert`;
    return this._http.post<AdminCatalogUpsertResult>(apiUrl, data)
      .pipe(
        take(1)
      );
    // const response: AdminCatalogUpsertResult = {
    //   success: true,
    //   message: '1234567890',
    // };
    // return of(response).pipe(delay(1000));
  }

  public fetchSuperbidModels(pagination: AdminCatalogSuperbidModelPaginationPayload): Observable<AdminCatalogSuperbidModelPaginationResult> {
    const apiUrl = `${environment.api}/admin/modelSuperBid`;
    return this._http.post<AdminCatalogSuperbidModelPaginationResult>(apiUrl, pagination)
      .pipe(
        take(1)
      );
  }
}